import { ReactNode } from "react";
import { InputGroup, Spinner } from "react-bootstrap";

type Props = {
    children: ReactNode 
    processing?: boolean;
    className?: string;
    variant?: string;
}

export default function ProcessingGroup({ 
    children, 
    processing,
    className,
    variant = 'primary',
}: Props) {

    return (
        <InputGroup className={className}>
            {processing && 
                <InputGroup.Text>
                    <Spinner animation='border' size='sm' variant={variant}/>
                </InputGroup.Text>
            }
            {children}
        </InputGroup>
    );
}